import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";

interface SkeletonProps {
  className?: string;
}

const SkeletonPulse = ({ className }: SkeletonProps) => (
  <div 
    className={cn(
      "bg-gradient-to-r from-muted via-muted/40 to-muted bg-[length:250%_100%] animate-shimmer rounded",
      className
    )}
  />
);

interface TripCardSkeletonProps {
  index?: number;
}

const TripCardSkeleton = ({ index = 0 }: TripCardSkeletonProps) => {
  return (
    <div
      className="animate-fade-in-up"
      style={{ animationDelay: `${index * 0.08}s` }}
    >
      <Card className="overflow-hidden">
        <div className="relative h-48 w-full overflow-hidden">
          <SkeletonPulse className="h-full w-full rounded-none" />
          <div className="absolute top-3 left-3">
            <SkeletonPulse className="h-5 w-16 rounded-full" />
          </div>
          <div className="absolute top-3 right-3">
            <SkeletonPulse className="h-8 w-8 rounded-full" />
          </div>
        </div>
        
        <CardContent className="p-4 space-y-3">
          <SkeletonPulse className="h-6 w-4/5" />
          <div className="flex items-center gap-2">
            <SkeletonPulse className="h-4 w-4 rounded-full" />
            <SkeletonPulse className="h-4 w-28" />
          </div>
          <div className="flex items-center gap-2">
            <SkeletonPulse className="h-4 w-4 rounded-full" />
            <SkeletonPulse className="h-4 w-36" />
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default TripCardSkeleton;
